import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { uniqueId } from "lodash";

import { COMPLIANCE_API_URLS, ComplianceAPI } from "../../../../api/compliance";
import { complianceSearchActions } from "../../../../reducers/complianceSearch";
import { Table } from "../../../../components/ui";

import usePagination from "../../../../hooks/usePagination";
import { TOP_LIVE_LOSERS_COLUMNS } from "../../constants";
import { SectionTitle } from "../../styledComponents";

const TopLiveLosers: React.FC = () => {
  const dispatch = useDispatch();
  const pagination = usePagination();

  const { data, loading } = useSelector((state) => state.complianceSearch.topLiveLosers);

  const { isError, error } = useQuery({
    queryKey: [COMPLIANCE_API_URLS.getTopLiveLosers, pagination.limit, pagination.page],
    async queryFn({ signal }) {
      dispatch(complianceSearchActions.fetchTopLiveLosersRequest());
      const query = new URLSearchParams();
      query.append("limit", pagination.limit.toString());
      query.append("page", pagination.page.toString());

      const response = await ComplianceAPI.getTopLiveLosersRequest(query.toString(), signal);

      dispatch(complianceSearchActions.fetchTopLiveLosersSuccess(response.data));
      pagination.setCount(response.data.results.count);
      return response;
    },
  });

  useEffect(() => {
    if (isError && error) {
      dispatch(complianceSearchActions.fetchTopLiveLosersFailed());
      console.error("Error fetching Top Live losers", error);
    }
  }, [isError, error]);

  useEffect(() => {
    pagination.setPage(0);
  }, [pagination.limit]);

  return (
    <SectionTitle title="Top Live losers">
      <Table
        columns={TOP_LIVE_LOSERS_COLUMNS}
        loading={loading}
        extractKey={(row) => `${row.name}_${uniqueId()}`}
        data={data.results.rows}
        pagination={pagination}
        csv_table_name="Top Live losses, and top LiveSim takers - Top Live losers"
      />
    </SectionTitle>
  );
};

export default TopLiveLosers;
